import { GA_Events } from 'types/enums'

const pageView = () => {
  window.dataLayer.push({
    event: GA_Events.PageView,
    page_location: window.location.href,
    page_title: document.title,
  })
}

const addFavorite = (entityId: string) => {
  window.dataLayer.push({
    event: GA_Events.AddToFavorites,
    page_location: window.location.href,
    page_title: document.title,
    entityId: entityId,
  })
}

const removeFavorite = () => {
  window.dataLayer.push({
    event: GA_Events.RemoveFromFavorites,
    page_location: window.location.href,
    page_title: document.title,
  })
}

const AnalyticsService = {
  addFavorite,
  removeFavorite,
  pageView,
}

export default AnalyticsService
